module.exports = __webpack_public_path__ + "media/images/front/sp/for-doctors/img_reservation-7a02aa2be4c41cf3d15e87a0dea4de5d.png";